import { type } from '@ngrx/signals';
import { eventGroup } from '@ngrx/signals/events';
import {
  CreatedShareLink,
  ShareLink,
  ShareLinkCreate,
  ShareLinkError,
} from '../../models/share-link';

export const shareLinkEvents = eventGroup({
  source: 'Share Link',
  events: {
    clear: type<void>(),

    loadLinks: type<void>(),
    loadedLinks: type<ShareLink[]>(),
    loadLinksFailed: type<ShareLinkError>(),

    createLink: type<ShareLinkCreate>(),
    createdLink: type<CreatedShareLink>(),
    createLinkFailed: type<ShareLinkError>(),
    resetCreate: type<void>(),

    revokeLink: type<number>(),
    revokedLink: type<number>(),
    revokeLinkFailed: type<{ id: number; error: ShareLinkError }>(),
  },
});
